import Jean1 from '../../assets/Jeans/jean (1).jpeg';
import Jean2 from '../../assets/Jeans/jean (4).jpeg';
import Jean3 from '../../assets/Jeans/jean (3).jpeg';
import Jean4 from '../../assets/Jeans/jean (2).jpeg';
import Jean5 from '../../assets/Jeans/jean (5).jpeg';

import Iphone7 from '../../assets/Iphones/iphone 7.jpg';
import Iphone7Plus from '../../assets/Iphones/iphone 7 plus.jpg';
import Iphone8 from '../../assets/Iphones/iphone 8.jpg';
import Iphone8Plus from '../../assets/Iphones/iphone 8 plus.jpg';
import IphoneX from '../../assets/Iphones/iphone x.jpg';
import IphoneXR from '../../assets/Iphones/iphone xr.jpg';
import Iphone11 from '../../assets/Iphones/iphone 11.jpg';
import Iphone11Pro from '../../assets/Iphones/iphone 11 pro.jpg';
import Iphone12 from '../../assets/Iphones/iphone 12.jpg';

// Curly Hair Images
import ddjerry1 from '../../assets/Hair/curly/ddjerry1.jpeg';
import ddjerry2 from '../../assets/Hair/curly/ddjerry2.jpeg';
import ddjerry3 from '../../assets/Hair/curly/ddjerry3.jpeg';

import ddwater1 from '../../assets/Hair/curly/ddwater1.jpeg';
import ddwater2 from '../../assets/Hair/curly/ddwater2.jpeg';
import ddwater3 from '../../assets/Hair/curly/ddwater3.jpeg';
import ddwater4 from '../../assets/Hair/curly/ddwater4.jpeg';
import ddwater5 from '../../assets/Hair/curly/ddwater5.jpeg';

import jerry1 from '../../assets/Hair/curly/jerry1.jpeg';
import jerry2 from '../../assets/Hair/curly/jerry2.jpeg';
import jerry3 from '../../assets/Hair/curly/jerry3.jpeg';
import jerry4 from '../../assets/Hair/curly/jerry4.jpeg';
import jerry5 from '../../assets/Hair/curly/jerry5.jpeg';
import jerry6 from '../../assets/Hair/curly/jerry6.jpeg';
import jerry7 from '../../assets/Hair/curly/jerry7.jpeg';

import sddjerry1 from '../../assets/Hair/curly/sddjerry1.jpeg';
import sddjerry2 from '../../assets/Hair/curly/sddjerry2.jpeg';
import sddjerry3 from '../../assets/Hair/curly/sddjerry3.jpeg';
import sddjerry4 from '../../assets/Hair/curly/sddjerry4.jpeg';
import sddjerry5 from '../../assets/Hair/curly/sddjerry5.jpeg';
import sddjerry6 from '../../assets/Hair/curly/sddjerry6.jpeg';
import sddjerry7 from '../../assets/Hair/curly/sddjerry7.jpeg';

import sddpixie1 from '../../assets/Hair/curly/sddpixie1.jpeg';
import sddpixie2 from '../../assets/Hair/curly/sddpixie2.jpeg';
import sddpixie3 from '../../assets/Hair/curly/sddpixie3.jpeg';
import sddpixie4 from '../../assets/Hair/curly/sddpixie4.jpeg';
import sddpixie5 from '../../assets/Hair/curly/sddpixie5.jpeg';
import sddpixie6 from '../../assets/Hair/curly/sddpixie6.jpeg';
import sddpixie7 from '../../assets/Hair/curly/sddpixie7.jpeg';

import sddwater1 from '../../assets/Hair/curly/sddwater1.jpeg';
import sddwater2 from '../../assets/Hair/curly/sddwater2.jpeg';
import sddwater3 from '../../assets/Hair/curly/sddwater3.jpeg';
import sddwater4 from '../../assets/Hair/curly/sddwater4.jpeg';
import sddwater5 from '../../assets/Hair/curly/sddwater5.jpeg';

import water1 from '../../assets/Hair/curly/water1.jpeg';
import water2 from '../../assets/Hair/curly/water2.jpeg';
import water3 from '../../assets/Hair/curly/water3.jpeg';
import water4 from '../../assets/Hair/curly/water4.jpeg';
import water5 from '../../assets/Hair/curly/water5.jpeg';
import water6 from '../../assets/Hair/curly/water6.jpeg';

// Straight Hair Images
import singleDrawn1 from '../../assets/Hair/Single Drawn/Single Drawn 1.jpeg';
import singleDrawn2 from '../../assets/Hair/Single Drawn/Single Drawn 2.jpeg';
import singleDrawn3 from '../../assets/Hair/Single Drawn/Single Drawn 3.jpeg';
import singleDrawn4 from '../../assets/Hair/Single Drawn/Single Drawn 4.jpeg';
import singleDrawn5 from '../../assets/Hair/Single Drawn/Single Drawn 5.jpeg';
import singleDrawn6 from '../../assets/Hair/Single Drawn/Single Drawn 6.jpeg';
import singleDrawn7 from '../../assets/Hair/Single Drawn/Single Drawn 7.jpeg';
import singleDrawn8 from '../../assets/Hair/Single Drawn/Single Drawn 8.jpeg';
import singleDrawn9 from '../../assets/Hair/Single Drawn/Single Drawn 9.jpeg';
import singleDrawn10 from '../../assets/Hair/Single Drawn/Single Drawn 10.jpeg';

import doubleDrawn1 from '../../assets/Hair/Double Drawn/Double Drawn 1.jpeg';
import doubleDrawn2 from '../../assets/Hair/Double Drawn/Double Drawn 2.jpeg';
import doubleDrawn3 from '../../assets/Hair/Double Drawn/Double Drawn 3.jpeg';
import doubleDrawn4 from '../../assets/Hair/Double Drawn/Double Drawn 4.jpeg';
import doubleDrawn5 from '../../assets/Hair/Double Drawn/Double Drawn 5.jpeg';

import kinky1 from '../../assets/Hair/Kinky/Kinky 1.jpeg';
import kinky2 from '../../assets/Hair/Kinky/Kinky 2.jpeg';
import kinky3 from '../../assets/Hair/Kinky/Kinky 3.jpeg';
import kinky4 from '../../assets/Hair/Kinky/Kinky 4.jpeg';
import kinky5 from '../../assets/Hair/Kinky/Kinky 5.jpeg';

import superDD1 from '../../assets/Hair/Super Double Drawn/Super Double Drawn 1.jpeg';
import superDD2 from '../../assets/Hair/Super Double Drawn/Super Double Drawn 2.jpeg';
import superDD3 from '../../assets/Hair/Super Double Drawn/Super Double Drawn 3.jpeg';
import superDD4 from '../../assets/Hair/Super Double Drawn/Super Double Drawn 4.jpeg';
import superDD5 from '../../assets/Hair/Super Double Drawn/Super Double Drawn 5.jpeg';
import superDD6 from '../../assets/Hair/Super Double Drawn/Super Double Drawn 6.jpeg';
import superDD7 from '../../assets/Hair/Super Double Drawn/Super Double Drawn Choc 1.jpeg';
import superDD8 from '../../assets/Hair/Super Double Drawn/Super Double Drawn Choc 2.jpeg';
import superDD9 from '../../assets/Hair/Super Double Drawn/Super Double Drawn Choc 3.jpeg';
import superDD10 from '../../assets/Hair/Super Double Drawn/Super Double Drawn Choc 4.jpeg';
import superDD11 from '../../assets/Hair/Super Double Drawn/Super Double Drawn Choc 5.jpeg';

import lindyChoc1 from '../../assets/Hair/Lindy Choc/Lindy Choc 1.jpeg';
import lindyChoc2 from '../../assets/Hair/Lindy Choc/Lindy Choc 2.jpeg';
import lindyChoc3 from '../../assets/Hair/Lindy Choc/Lindy Choc 3.jpeg';
import lindyChoc4 from '../../assets/Hair/Lindy Choc/Lindy Choc 4.jpeg';

// ========== ALL PRODUCTS DATABASE ==========
export const allProducts = [
  // ========== JEANS PRODUCTS ==========
  {
    id: 'jeans-1',
    name: "H&M Ashwood Jeans",
    baseName: "H&M Ashwood Jeans",
    price: 299.99,
    image: Jean1,
    images: [Jean1],
    category: "Jeans",
    subcategory: "Slim Fit",
    description: "Stonewashed slim-fit jeans with a modern ash grey finish.",
    url: "/jeans?product=jeans-1",
    page: "jeans",
    type: "clothing",
    tags: ["hm", "ashwood", "slim fit", "grey", "jeans"],
    featured: true,
    status: "In Stock",
    color: "Ash Grey"
  },
  {
    id: 'jeans-2',
    name: "Zara Misty Blue Skirt",
    baseName: "Zara Misty Blue Skirt",
    price: 399.99,
    image: Jean2,
    images: [Jean2],
    category: "Jeans",
    subcategory: "A-Line",
    description: "A-line denim skirt in a soft misty blue wash.",
    url: "/jeans?product=jeans-2",
    page: "jeans",
    type: "clothing",
    tags: ["zara", "denim skirt", "misty blue", "skirt"],
    featured: false,
    status: "In Stock",
    color: "Misty Blue"
  },
  {
    id: 'jeans-3',
    name: "Oceanline Jean",
    baseName: "Oceanline Jean",
    price: 289.99,
    image: Jean3,
    images: [Jean3],
    category: "Jeans",
    subcategory: "Straight Fit",
    description: "Classic straight-leg jeans in deep ocean blue.",
    url: "/jeans?product=jeans-3",
    page: "jeans",
    type: "clothing",
    tags: ["oceanline", "straight fit", "blue", "jeans"],
    featured: false,
    status: "In Stock",
    color: "Deep Blue"
  },
  {
    id: 'jeans-4',
    name: "Trueblue Skinny Jean",
    baseName: "Trueblue Skinny Jean",
    price: 299.99,
    image: Jean4,
    images: [Jean4],
    category: "Jeans",
    subcategory: "Skinny Fit",
    description: "High-stretch skinny jeans in true blue indigo.",
    url: "/jeans?product=jeans-4",
    page: "jeans",
    type: "clothing",
    tags: ["trueblue", "skinny", "indigo", "jeans"],
    featured: false,
    status: "In Stock",
    color: "True Blue"
  },
  {
    id: 'jeans-5',
    name: "Zara Denim Jacket",
    baseName: "Zara Denim Jacket",
    price: 449.99,
    image: Jean5,
    images: [Jean5],
    category: "Jeans",
    subcategory: "Jacket",
    description: "Oversized denim jacket with raw hem details.",
    url: "/jeans?product=jeans-5",
    page: "jeans",
    type: "clothing",
    tags: ["zara", "denim jacket", "jacket"],
    featured: true,
    status: "In Stock",
    color: "Medium Wash"
  },

  // ========== IPHONES ==========
  {
    id: 'iphone-1',
    name: "iPhone 7",
    baseName: "iPhone 7",
    price: 2500.00,
    image: Iphone7,
    images: [Iphone7],
    category: "iPhones",
    subcategory: "iPhone 7 Series",
    description: "iPhone 7 - Pre-Owned model",
    url: "/iphones?product=iphone-1",
    page: "iphones",
    type: "electronics",
    storage: "32GB",
    condition: "Pre-Owned",
    tags: ["iphone 7", "pre-owned", "32gb", "apple"],
    featured: false,
    status: "Available",
    color: "Black",
    modelYear: "2016",
    series: "7"
  },
  {
    id: 'iphone-2',
    name: "iPhone 7 Plus",
    baseName: "iPhone 7 Plus",
    price: 3050.00,
    image: Iphone7Plus,
    images: [Iphone7Plus],
    category: "iPhones",
    subcategory: "iPhone 7 Series",
    description: "iPhone 7 Plus - Pre-Owned model",
    url: "/iphones?product=iphone-2",
    page: "iphones",
    type: "electronics",
    storage: "32GB",
    condition: "Pre-Owned",
    tags: ["iphone 7 plus", "pre-owned", "32gb", "apple"],
    featured: false,
    status: "Available",
    color: "Rose Gold",
    modelYear: "2016",
    series: "7"
  },
  {
    id: 'iphone-3',
    name: "iPhone 8",
    baseName: "iPhone 8",
    price: 2950.00,
    image: Iphone8,
    images: [Iphone8],
    category: "iPhones",
    subcategory: "iPhone 8 Series",
    description: "iPhone 8 - Pre-Owned model",
    url: "/iphones?product=iphone-3",
    page: "iphones",
    type: "electronics",
    storage: "64GB",
    condition: "Pre-Owned",
    tags: ["iphone 8", "pre-owned", "64gb", "apple"],
    featured: false,
    status: "Available",
    color: "Space Gray",
    modelYear: "2017",
    series: "8"
  },
  {
    id: 'iphone-4',
    name: "iPhone 8 Plus",
    baseName: "iPhone 8 Plus",
    price: 3600.00,
    image: Iphone8Plus,
    images: [Iphone8Plus],
    category: "iPhones",
    subcategory: "iPhone 8 Series",
    description: "iPhone 8 Plus - Pre-Owned model",
    url: "/iphones?product=iphone-4",
    page: "iphones",
    type: "electronics",
    storage: "64GB",
    condition: "Pre-Owned",
    tags: ["iphone 8 plus", "pre-owned", "64gb", "apple"],
    featured: false,
    status: "Available",
    color: "Gold",
    modelYear: "2017",
    series: "8"
  },
  {
    id: 'iphone-5',
    name: "iPhone X",
    baseName: "iPhone X",
    price: 3900.00,
    image: IphoneX,
    images: [IphoneX],
    category: "iPhones",
    subcategory: "iPhone X Series",
    description: "iPhone X - Pre-Owned model",
    url: "/iphones?product=iphone-5",
    page: "iphones",
    type: "electronics",
    storage: "64GB",
    condition: "Pre-Owned",
    tags: ["iphone x", "pre-owned", "64gb", "apple"],
    featured: false,
    status: "Available",
    color: "Silver",
    modelYear: "2017",
    series: "X"
  },
  {
    id: 'iphone-6',
    name: "iPhone XR",
    baseName: "iPhone XR",
    price: 4100.00,
    image: IphoneXR,
    images: [IphoneXR],
    category: "iPhones",
    subcategory: "iPhone XR Series",
    description: "iPhone XR - Pre-Owned model",
    url: "/iphones?product=iphone-6",
    page: "iphones",
    type: "electronics",
    storage: "64GB",
    condition: "Pre-Owned",
    tags: ["iphone xr", "pre-owned", "64gb", "apple"],
    featured: false,
    status: "Available",
    color: "Coral",
    modelYear: "2018",
    series: "XR"
  },
  {
    id: 'iphone-7',
    name: "iPhone 11",
    baseName: "iPhone 11",
    price: 5100.00,
    image: Iphone11,
    images: [Iphone11],
    category: "iPhones",
    subcategory: "iPhone 11 Series",
    description: "iPhone 11 - Pre-Owned model",
    url: "/iphones?product=iphone-7",
    page: "iphones",
    type: "electronics",
    storage: "64GB",
    condition: "Pre-Owned",
    tags: ["iphone 11", "pre-owned", "64gb", "apple"],
    featured: true,
    status: "Available",
    color: "Purple",
    modelYear: "2019",
    series: "11"
  },
  {
    id: 'iphone-8',
    name: "iPhone 11 Pro",
    baseName: "iPhone 11 Pro",
    price: 6400.00,
    image: Iphone11Pro,
    images: [Iphone11Pro],
    category: "iPhones",
    subcategory: "iPhone 11 Series",
    description: "iPhone 11 Pro - Pre-Owned model",
    url: "/iphones?product=iphone-8",
    page: "iphones",
    type: "electronics",
    storage: "64GB",
    condition: "Pre-Owned",
    tags: ["iphone 11 pro", "pre-owned", "64gb", "apple"],
    featured: true,
    status: "Low Stock",
    color: "Midnight Green",
    modelYear: "2019",
    series: "11"
  },
  {
    id: 'iphone-9',
    name: "iPhone 12",
    baseName: "iPhone 12",
    price: 6800.00,
    image: Iphone12,
    images: [Iphone12],
    category: "iPhones",
    subcategory: "iPhone 12 Series",
    description: "iPhone 12 - Pre-Owned model",
    url: "/iphones?product=iphone-9",
    page: "iphones",
    type: "electronics",
    storage: "64GB",
    condition: "Pre-Owned",
    tags: ["iphone 12", "pre-owned", "64gb", "apple"],
    featured: true,
    status: "Available",
    color: "Black",
    modelYear: "2020",
    series: "12"
  },

  // ========== CURLY HAIR PRODUCTS ==========
  {
    id: 'dd-jerry-curls',
    name: "13x4 Jerry Curls Double Drawn",
    baseName: "DD Jerry Curls",
    price: 1150.00,
    image: ddjerry1,
    images: [ddjerry1, ddjerry2, ddjerry3],
    category: "Hair",
    subcategory: "Curly",
    hairType: "curly",
    collection: "DD Jerry",
    description: "Double Drawn Jerry Curls with uniform thickness and beautiful defined curls. Available in 1B and Piano colors.",
    url: "/curly-hair?product=dd-jerry-curls",
    page: "curly-hair",
    type: "beauty",
    tags: ["curly hair", "double drawn", "jerry curls", "13x4 frontal", "human hair"],
    featured: true,
    status: "Available",
    hasBadge: true,
    badgeText: "DD"
  },
  {
    id: 'dd-waterwave',
    name: "13x4 Waterwave Double Drawn",
    baseName: "DD Waterwave",
    price: 1150.00,
    image: ddwater1,
    images: [ddwater1, ddwater2, ddwater3, ddwater4, ddwater5],
    category: "Hair",
    subcategory: "Curly",
    hairType: "curly",
    collection: "DD Waterwave",
    description: "Double Drawn Waterwave with natural-looking waves and consistent thickness. Perfect for voluminous styles.",
    url: "/curly-hair?product=dd-waterwave",
    page: "curly-hair",
    type: "beauty",
    tags: ["curly hair", "waterwave", "double drawn", "13x4 frontal", "human hair"],
    featured: false,
    status: "Available",
    hasBadge: true,
    badgeText: "DD"
  },
  {
    id: 'jerry-curls',
    name: "13x4 Jerry Curls",
    baseName: "Jerry Curls",
    price: 1000.00,
    image: jerry1,
    images: [jerry1, jerry2, jerry3, jerry4, jerry5, jerry6, jerry7],
    category: "Hair",
    subcategory: "Curly",
    hairType: "curly",
    collection: "Jerry Curls",
    description: "Classic Jerry Curls with spiral curls pattern. Available in various lengths and colors for versatile styling.",
    url: "/curly-hair?product=jerry-curls",
    page: "curly-hair",
    type: "beauty",
    tags: ["curly hair", "jerry curls", "13x4 frontal", "human hair"],
    featured: false,
    status: "Available",
    hasBadge: false
  },
  {
    id: 'sdd-jerry-curls',
    name: "13x4 SDD Jerry Curls",
    baseName: "SDD Jerry Curls",
    price: 1850.00,
    image: sddjerry1,
    images: [sddjerry1, sddjerry2, sddjerry3, sddjerry4, sddjerry5, sddjerry6, sddjerry7],
    category: "Hair",
    subcategory: "Curly",
    hairType: "curly",
    collection: "SDD Jerry",
    description: "Super Double Drawn Jerry Curls with defined spiral curls and maximum thickness consistency. Luxury quality.",
    url: "/curly-hair?product=sdd-jerry-curls",
    page: "curly-hair",
    type: "beauty",
    tags: ["curly hair", "super double drawn", "sdd", "jerry curls", "13x4 frontal", "luxury"],
    featured: true,
    status: "Available",
    hasBadge: true,
    badgeText: "SDD"
  },
  {
    id: 'sdd-pixie-curls',
    name: "13x4 SDD Pixie Curls",
    baseName: "SDD Pixie Curls",
    price: 2450.00,
    image: sddpixie1,
    images: [sddpixie1, sddpixie2, sddpixie3, sddpixie4, sddpixie5, sddpixie6, sddpixie7],
    category: "Hair",
    subcategory: "Curly",
    hairType: "curly",
    collection: "SDD Pixie",
    description: "Super Double Drawn Pixie Curls frontal wig with tight, defined curls. Premium quality with maximum volume.",
    url: "/curly-hair?product=sdd-pixie-curls",
    page: "curly-hair",
    type: "beauty",
    tags: ["curly hair", "pixie curls", "sdd", "13x4 frontal", "human hair", "luxury"],
    featured: true,
    status: "Available",
    hasBadge: true,
    badgeText: "SDD"
  },
  {
    id: 'sdd-waterwave',
    name: "13x4 SDD Water Wave",
    baseName: "SDD Water Wave",
    price: 1550.00,
    image: sddwater1,
    images: [sddwater1, sddwater2, sddwater3, sddwater4, sddwater5],
    category: "Hair",
    subcategory: "Curly",
    hairType: "curly",
    collection: "SDD Waterwave",
    description: "Super Double Drawn Water Wave with natural, beachy waves. High-density frontal with superior quality.",
    url: "/curly-hair?product=sdd-waterwave",
    page: "curly-hair",
    type: "beauty",
    tags: ["curly hair", "water wave", "sdd", "13x4 frontal", "human hair", "luxury"],
    featured: false,
    status: "Available",
    hasBadge: true,
    badgeText: "SDD"
  },
  {
    id: 'waterwave',
    name: "13x4 Waterwave",
    baseName: "Waterwave",
    price: 1480.00,
    image: water1,
    images: [water1, water2, water3, water4, water5, water6],
    category: "Hair",
    subcategory: "Curly",
    hairType: "curly",
    collection: "Waterwave",
    description: "Classic Waterwave frontal with natural wave pattern. Versatile styling options for everyday wear.",
    url: "/curly-hair?product=waterwave",
    page: "curly-hair",
    type: "beauty",
    tags: ["curly hair", "waterwave", "13x4 frontal", "human hair"],
    featured: false,
    status: "Available",
    hasBadge: false
  },

  // ========== STRAIGHT HAIR PRODUCTS ==========
  {
    id: 'single-drawn',
    name: "Single Drawn Virgin Hair Collection",
    baseName: "Single Drawn Hair",
    price: 1250.00,
    image: singleDrawn1,
    images: [singleDrawn1, singleDrawn2, singleDrawn3, singleDrawn4, singleDrawn5, 
            singleDrawn6, singleDrawn7, singleDrawn8, singleDrawn9, singleDrawn10],
    category: "Hair",
    subcategory: "Straight",
    hairType: "straight",
    collection: "Single Drawn",
    description: "Our premium Single Drawn hair collection features carefully selected strands with minimal thickness variation. Each bundle is 100% virgin human hair.",
    url: "/straight-hair?product=single-drawn",
    page: "straight-hair",
    type: "beauty",
    tags: ["straight hair", "single drawn", "virgin hair", "human hair"],
    featured: true,
    status: "Available",
    hasBadge: true,
    badgeText: "Single Drawn"
  },
  {
    id: 'double-drawn',
    name: "Double Drawn Premium Collection",
    baseName: "Double Drawn Hair",
    price: 1850.00,
    image: doubleDrawn1,
    images: [doubleDrawn1, doubleDrawn2, doubleDrawn3, doubleDrawn4, doubleDrawn5],
    category: "Hair",
    subcategory: "Straight",
    hairType: "straight",
    collection: "Double Drawn",
    description: "Double Drawn hair features superior thickness consistency with more uniform strands, offering fuller volume and luxurious density.",
    url: "/straight-hair?product=double-drawn",
    page: "straight-hair",
    type: "beauty",
    tags: ["straight hair", "double drawn", "virgin hair", "human hair", "premium"],
    featured: false,
    status: "Available",
    hasBadge: false
  },
  {
    id: 'kinky',
    name: "Kinky Straight & Curly Collection",
    baseName: "Kinky Hair",
    price: 1750.00,
    image: kinky1,
    images: [kinky1, kinky2, kinky3, kinky4, kinky5],
    category: "Hair",
    subcategory: "Straight",
    hairType: "straight",
    collection: "Kinky",
    description: "Our Kinky collection offers natural-looking texture with beautiful curls and waves, perfect for afro-textured styles and voluminous looks.",
    url: "/straight-hair?product=kinky",
    page: "straight-hair",
    type: "beauty",
    tags: ["straight hair", "kinky", "textured hair", "human hair", "natural"],
    featured: false,
    status: "Available",
    hasBadge: false
  },
  {
    id: 'super-dd',
    name: "Super Double Drawn Luxury Collection",
    baseName: "Super DD Hair",
    price: 2450.00,
    image: superDD1,
    images: [superDD1, superDD2, superDD3, superDD4, superDD5, superDD6, 
            superDD7, superDD8, superDD9, superDD10, superDD11],
    category: "Hair",
    subcategory: "Straight",
    hairType: "straight",
    collection: "Super DD",
    description: "Super Double Drawn represents the highest quality with maximum thickness consistency. Perfect for luxury installations and runway looks.",
    url: "/straight-hair?product=super-dd",
    page: "straight-hair",
    type: "beauty",
    tags: ["straight hair", "super double drawn", "sdd", "luxury hair", "virgin hair"],
    featured: true,
    status: "Available",
    hasBadge: false
  },
  {
    id: 'lindy-choc',
    name: "Lindy Chocolate Exclusive Collection",
    baseName: "Lindy Chocolate Hair",
    price: 3250.00,
    image: lindyChoc1,
    images: [lindyChoc1, lindyChoc2, lindyChoc3, lindyChoc4],
    category: "Hair",
    subcategory: "Straight",
    hairType: "straight",
    collection: "Lindy Choc",
    description: "Our exclusive Lindy Chocolate collection features rich chocolate brown tones with silky smooth texture. Limited edition luxury hair.",
    url: "/straight-hair?product=lindy-choc",
    page: "straight-hair",
    type: "beauty",
    tags: ["straight hair", "lindy chocolate", "chocolate brown", "luxury hair", "exclusive"],
    featured: true,
    status: "Available",
    hasBadge: false
  }
];

// Search function
export const searchAllProducts = (query) => {
  if (!query || query.trim() === '') return [];
  
  const searchTerm = query.toLowerCase().trim();
  
  const scoredProducts = allProducts.map(product => {
    let score = 0;
    
    // Name matches (highest priority)
    if (product.name?.toLowerCase().includes(searchTerm)) {
      score += 100;
      if (product.name.toLowerCase() === searchTerm) score += 50;
    }
    if (product.baseName?.toLowerCase().includes(searchTerm)) {
      score += 90;
    }
    
    // Category matches
    if (product.category?.toLowerCase().includes(searchTerm)) {
      score += 80;
    }
    
    // Subcategory matches
    if (product.subcategory?.toLowerCase().includes(searchTerm)) {
      score += 70;
    }
    
    // Collection matches
    if (product.collection?.toLowerCase().includes(searchTerm)) {
      score += 60;
    }
    
    // Description matches
    if (product.description?.toLowerCase().includes(searchTerm)) {
      score += 40;
    }
    
    // Tag matches
    product.tags?.forEach(tag => {
      if (tag.toLowerCase().includes(searchTerm)) {
        score += 30;
      }
    });
    
    // Hair type matches
    if (product.hairType?.toLowerCase().includes(searchTerm)) {
      score += 50;
    }
    
    // Color matches
    if (product.color?.toLowerCase().includes(searchTerm)) {
      score += 45;
    }
    
    // Type matches
    if (product.type?.toLowerCase().includes(searchTerm)) {
      score += 20;
    }
    
    // Page matches
    if (product.page?.toLowerCase().includes(searchTerm)) {
      score += 10;
    }
    
    // Featured products get a small boost
    if (product.featured) {
      score += 5;
    }
    
    return { ...product, score };
  });
  
  return scoredProducts
    .filter(product => product.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 50);
};

export const getAllCategories = () => {
  return [...new Set(allProducts.map(p => p.category))];
};

export const getPopularSearches = () => {
  return [
    "iPhone 12",
    "iPhone 11 Pro",
    "Jeans",
    "Curly Hair",
    "Straight Hair",
    "Jerry Curls",
    "Waterwave",
    "SDD Hair",
    "Double Drawn",
    "Super Double Drawn",
    "Single Drawn",
    "Kinky Hair",
    "Lindy Chocolate",
    "H&M Jeans",
    "Zara Denim",
    "Virgin Hair"
  ];
};

export const getFeaturedProducts = () => {
  return allProducts.filter(product => product.featured);
};

export const getProductsByCategory = (category) => {
  return allProducts.filter(product => 
    product.category?.toLowerCase() === category.toLowerCase()
  );
};

export const getProductsByPage = (page) => {
  return allProducts.filter(product => 
    product.page?.toLowerCase() === page.toLowerCase()
  );
};

export const getProductById = (id) => {
  return allProducts.find(product => product.id === id);
};

export const getTotalProductsCount = () => {
  return allProducts.length;
};

export const getProductStats = () => {
  return {
    total: allProducts.length,
    jeans: allProducts.filter(p => p.category === 'Jeans').length,
    iphones: allProducts.filter(p => p.category === 'iPhones').length,
    hair: allProducts.filter(p => p.category === 'Hair').length,
    curlyHair: allProducts.filter(p => p.hairType === 'curly').length,
    straightHair: allProducts.filter(p => p.hairType === 'straight').length,
    featured: allProducts.filter(p => p.featured).length,
    inStock: allProducts.filter(p => p.status === 'Available' || p.status === 'In Stock').length
  };
};